// extracted by mini-css-extract-plugin
export default {"button":"TimeLimitButton_button__1fUEA","button_disabled":"TimeLimitButton_button_disabled__n3lCl"};